import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { getAccountType } from "../_metronic/_helpers";
import { useSelector, shallowEqual } from "react-redux";
import { AdminUIProvider } from "./modules/Admin/AdminProvider";
// import { BuilderPage } from "./pages/BuilderPage";
// import { DashboardPage } from "./pages/DashboardPage";
import useLazyLoad from "../hooks/useLazyLoad";

const DashboardPage = useLazyLoad(() =>
  import("./modules/Dashboard/DashboardPage")
);

// const Welcome = useLazyLoad(() => import("./pages/WelcomePage"));
const Configurations = useLazyLoad(() =>
  import("./modules/Configurations/Configurations")
);

const Reports = useLazyLoad(() => import("./modules/Reports"));

const Transactions = useLazyLoad(() =>
  import("./modules/Transactions/Transactions")
);

const Accounting = useLazyLoad(() => import("./modules/Accounting/Accounting"));

const UserProfilepage = useLazyLoad(() =>
  import("./modules/UserProfile/UserProfilePage")
);

const AdminPage = useLazyLoad(() => import("./modules/Admin/AdminPage"));

export default function BasePage() {
  const { authUser } = useSelector(
    ({ auth }) => ({
      authUser: auth.user,
    }),
    shallowEqual
  );

  const { accountType = undefined } = authUser;

  const [mainAccountType] = getAccountType(accountType);

  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <AdminUIProvider>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            /* Redirect from root URL to /dashboard. */
            <Redirect exact from="/" to="/dashboard" />
          }
          <Route path="/transactions" component={Transactions} />
          <Route path="/configurations" component={Configurations} />
          <Route path="/reports" component={Reports} />
          <Route path="/accounting" component={Accounting} />
          <ContentRoute path="/dashboard" component={DashboardPage} />
          {/* <ContentRoute path="/builder" component={BuilderPage} /> */}

          <Route path="/user-profile" component={UserProfilepage} />

          {accountType && mainAccountType === "administrator" && (
            <Route path="/admin" component={AdminPage} />
          )}

          <Redirect to="/error/error-v1" />
        </Switch>
      </Suspense>
    </AdminUIProvider>
  );
}
